import { useMemo } from "react";
import { Mapper } from "@/common/services/mapper";
import { Option } from "@/common/types/option";
import { useEstablishmentCompanies } from "@/features/establishments/hooks/useEstablishmentCompanies";
import { EstablishmentCompanyTransformer } from "@/features/establishments/services/establishmentCompanyTransformer";

export type MissionCompanyBranchOption = {
  id: string;
  display_name: string;
};

type UseMissionCompanyBranchesProps = {
  search?: string;
  enabled?: boolean;
};

export const useMissionCompanyBranches = ({
  search = "",
  enabled = true,
}: UseMissionCompanyBranchesProps = {}) => {
  const establishmentQuery = useEstablishmentCompanies<Option[]>({
    filters: {
      search,
      tmaisModuleEnabled: true 
    },
    mapper: Mapper.mapWithTransformer({
      transformer: EstablishmentCompanyTransformer.optionTransformer({
        valueFieldName: "matrix_branch_id",
      }),
    }),
    enabled,
  });

  const normalizedData = useMemo<MissionCompanyBranchOption[]>(() => {
    if (!establishmentQuery.data) return [];

    return establishmentQuery.data
      .map((option) => {
        if (!option.value) return null;
        return {
          id: String(option.value),
          display_name: option.label,
        };
      })
      .filter(
        (option): option is MissionCompanyBranchOption => option !== null,
      );
  }, [establishmentQuery.data]);

  return {
    ...establishmentQuery,
    data: normalizedData,
  };
};
